import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { Inconsistency } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetInconsistenciesByIds = ({
  matterId,
  inconsistencyIds,
}: {
  matterId: string;
  inconsistencyIds: string[];
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Inconsistency[]>(
    [QueryEntity.InconsistenciesByIds, { matterId, inconsistencyIds }],
    async () => {
      if (!matterId || inconsistencyIds.length === 0) {
        return [];
      }

      // Join IDs with commas for the path parameter
      const idsParam = inconsistencyIds.join(',');
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/inconsistency/${idsParam}`, fetchConfigGET);

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }

      return res.json();
    },
    { refetchOnWindowFocus: false, enabled: !!matterId && inconsistencyIds.length > 0 },
  );
};
